module.exports = __webpack_public_path__ + "img/19.8a0da82d.png";